import { render } from "./ContentsTitleButton.vue?vue&type=template&id=45497ce4&scoped=true"
import script from "./ContentsTitleButton.vue?vue&type=script&lang=js"
export * from "./ContentsTitleButton.vue?vue&type=script&lang=js"

import "./ContentsTitleButton.vue?vue&type=style&index=0&id=45497ce4&scoped=true&lang=stylus"

import exportComponent from "F:\\xampp\\htdocs\\GITLAB\\2025\\tokyo-shoseki\\r8\\08sk_k\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45497ce4"]])

export default __exports__